import { AbstractBookingColumnController, AbstractDateRanger, AbstractTariffLoaderer, AbstractUserLoaderer } from '../../generated'
import { getApplicableDays } from '../booking/lib'

export default AbstractBookingColumnController
/** @constructor @extends {AbstractBookingColumnController} @suppress {checkTypes} */ function _BookingColumnController() {}

AbstractBookingColumnController.__implement(
 AbstractUserLoaderer, AbstractDateRanger, AbstractTariffLoaderer,
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  paint() {
   // delete state props to the instance.
   const{
    model:{uiState:uiState},
   }=this
   this.userLoader.resetLoadingState()
  },
 }),
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  get isOnService() {
   const{
    asITariffLoaderer:{tariffLoader:{state:{inventoryState}}},
   }=this
   return inventoryState == 12701
  },
  paint() {
   // delete state props to the instance.
   const{
    asITariffLoaderer:{tariffLoader:{state:{errorText}}},TariffLoaderError,
   }=this
   if(errorText)TariffLoaderError.innerHTML = errorText
   else TariffLoaderError.innerHTML = ''
  },
 }),
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  paint() {
   const{
    asIBookingColumnController:{isOnService},
    bookingState:{booking_id,currentTariff},
    bookingLoader:{state:{loading}},
    dateRange:{range,startHours},
    PayButton,
   }=this
   if(loading||!range||booking_id||isOnService||(currentTariff=='fiveHours'&&!startHours))PayButton.setAttribute('disabled', 'disabled')
   else PayButton.removeAttribute('disabled')
  },
 }),
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  paint() {
   const{bookingState:{booking_id},BookingId}=this
   if(booking_id)BookingId.innerHTML = booking_id
   else BookingId.innerHTML = ''
  },
 }),
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  paint() {
   const{bookingLoader:{state:{error,errorText}}, BookingLoaderError}=this
   if(error)BookingLoaderError.innerText = errorText
   else BookingLoaderError.innerText = ''
  },
 }),
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  async pay() {
   const{
    bookingState:{privacy_accepted},
    bookingLoader:{
     state:{loading},
     asIBookingLoader:{CreateBooking},
     asIStatefulLoader:{resetLoadingState:resetBookingLoaderLoadingState},
    },
    AcceptPrivacyText,
   }=this
   if (!privacy_accepted) {
    alert(AcceptPrivacyText.innerHTML)
    return
   }
   if (loading) {
    alert('Trying to create a booking right now.')
    return
   }
   resetBookingLoaderLoadingState()
   let{
    asIDateRanger:{dateRange:{StartDate,EndDate}},
    totalPrice,bookingState:{currentTariff},
   }=this
   // const res = confirm(`Оплатить ${totalPrice}?`)
   // if(!res) return
   if(StartDate && currentTariff && EndDate) {
    const booking_id = await CreateBooking({
     tariff:currentTariff,
     startDate:StartDate,
     endDate:EndDate,
    })
    const ev = new CustomEvent('booking', {
     detail: booking_id,
    })
    ev.booking_id = booking_id
    this.dispatchEvent(ev)
   } else {
    alert('Either dates or tariff are unavailable')
   }
  },
  getPrice() {
   const{
    asITariffLoaderer:{tariffLoader:{state:{
     twelveHourPrice,dailyPrice,fiveHourPrice,nightlyPrice,
     // twelveHourDiscount,
    }}},
    bookingState:{currentTariff},
   }=this
   let price
   switch(currentTariff) {
   case'day':{
    price=twelveHourPrice
    // if (twelveHourDiscount) {
    //   price -= twelveHourPrice * (twelveHourDiscount/100)
    // }
    break
   }
   case'night':price=nightlyPrice;break
   case'twentyFourHours':price=dailyPrice;break
   case'fiveHours':price=fiveHourPrice;break
   default:price=0
   }
   return /** @type {number} */ (price)
  },
  get totalPrice() {
   const{
    dateRange,
    dateRange:{state:{range,startDate,endDate}},asIBookingColumnController:{getPrice},
    asITariffLoaderer:{tariffLoader:{state:{twelveHourDiscount,dailyDiscount}}},
    bookingState:{currentTariff},
   }=this
   if (!range) return 0
   let price = getPrice()

   // if (currentTariff == 'day') {
   //  totalDiscount = price * (twelveHourDiscount/100)
   //  // price -= price * (twelveHourDiscount/100)
   // }else if (currentTariff=='twentyFourHours'&&dailyDiscount) {
   //  // debugger
   //  const days = getApplicableDays(dateRange,startDate,endDate)
   //  totalDiscount = days * (price * (dailyDiscount/100))
   // }else if (currentTariff=='night'&&dailyDiscount) {
   //  totalDiscount = price * (dailyDiscount/100)
   //  // debugger
   //  // price -= price * (dailyDiscount/100)
   //  // const days = getApplicableDays(dateRange,startDate,endDate)
   //  // totalDiscount = days * (price * (dailyDiscount/100))
   // }
   // else if(currentTariff=='night') {
   //  price -= price * (dailyDiscount/100)
   // }
   let totalPrice = price * range
   let totalDiscount = dailyDiscount?totalPrice * (dailyDiscount/100):0
   totalPrice-=totalDiscount

   // - totalDiscount
   return totalPrice +' руб.'
  },
  paint() {
   const{asIBookingColumnController:{totalPrice},TotalPrice}=this
   if (!totalPrice) TotalPrice.innerHTML = '—'
   else {
    TotalPrice.innerHTML = totalPrice
   }
   // const date = formatDate(endDate) || 'выберите дату'
   // EndDate.innerHTML = date
  },
 }),
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  paint() {
   const{asIBookingColumnController:{state:{discount}}}=this
   const Discount = this.element.querySelector('[data-id="Discount"]')
   if (!discount) Discount.innerHTML = '—'
   else {
    Discount.innerHTML = discount
   }
  },
 }),
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  paint() {
   const{
    asIDateRanger:{
     dateRange:{
      EndDate:ED,endHours,
      asIDateRange:{formatDate},
     },
    },
    EndDate,
   }=this
   const date = formatDate(ED,endHours!=null) || 'выберите дату'
   EndDate.innerHTML = date
  },
 }),
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  paint() {
   const{
    asIDateRanger:{
     dateRange:{
      StartDate:SD,startHours,
      asIDateRange:{formatDate},
     },
    },
    StartDate,
   }=this
   const date = formatDate(SD,startHours!=null) || 'выберите дату'
   StartDate.innerHTML = date
  },
 }),
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  paint() {
   const{asIBookingColumnController:{getPrice}}=this
   let price = getPrice()
   this.Tariff.innerHTML = price || '—'
  },
 }),
 _BookingColumnController.prototype = /** @type {!AbstractBookingColumnController} */ ({
  __$constructor() {
   const{asIStateful:{setDerivedState},asIUserLoaderer:{userLoader}}=this
   setDerivedState({
    /** @this {ru.hulkmoto.IUserLoader} */
    get uiState() {
     const{state:{user}}=this
     if(user)return'user'
     return undefined
    },
   }, /** @type {!ru.hulkmoto.IUserLoader} */ (userLoader))
  },
  ready() {
   const{SignupForm}=this
   SignupForm.addEventListener('signup', () => {
    setTimeout(() => {
     // this.SignupForm.collapse()
     this.userLoader.GetUser()
    }, 1500)
   })
   this.LoginForm.addEventListener('signin', () => {
    this.userLoader.GetUser()
   })
  },
  paint() {
   const{userLoader:{state:{user}}} = this
   const { UserName } = this

   if (user) {
    // const span = UserData.querySelector('span')
    // span.innerHTML = `${user['firstName']} ${user['lastName']}`
    // showBrick(UserData)
    UserName.innerText = user.firstName
   }

   // else hideBrick(UserData)

   // if (selectedDay) hideBrick(SelectDateHint)
   // else showBrick(SelectDateHint)

   // this.updateTableu()
   // // this.updateInput()
   // this.updatePre()
   // this.updateSelect()

   // if (loading) {
   //   BookBtn.disable()
   //   BookBtn.startLoading()
   // } else {
   //   BookBtn.stopLoading()

   //   if (selectedDay) {
   //     BookBtn.enable()
   //   } else {
   //     BookBtn.disable()
   //   }
   // }
   // // if bindings were available that could be done automatically
   // if (errorText) {
   //   BookingFormError.innerText = errorText
   //   showBrick(BookingFormError)
   // } else {
   //   hideBrick(BookingFormError)
   // }
   // if (booking_id) {
   //   BookBtn.disable()
   //   BookingFormSuccess.innerText = 'Бронирование успешно создано!'
   //   showBrick(BookingFormSuccess)
   // }
  },
  // selectDay(selectedDay) {
  //   const { asIStateful: { setState } } = this
  //   setState({
  //     selectedDay,
  //   })
  // },
  // selectHours(selectedHours) {
  //   const { asIStateful: { setState } } = this
  //   setState({
  //     selectedHours,
  //   })
  // },
  // getDayAvailability(year, month, date) {
  //   const { asIStateful: { state: { monthlyAvailability } } } = this
  //   if (!monthlyAvailability) return true

  //   for (const mo of monthlyAvailability) {
  //     const { date: d, year: y, month: m } = mo
  //     if (d == date && y == year && m == month) {
  //       return false
  //     }
  //   }
  //   return true
  // },
  switchUiState(uiState) {
   const{asIStateful:{setState}}=this
   setState({ uiState }) // check if one of?
  },
  async signout() {
   const{asIUserLoaderer:{userLoader:{asIUserLoader:{SignOut}}},asIBookingColumnController:{switchUiState}}=this
   const res = await SignOut()
   if (res) {
    switchUiState('signup-request')
    window.dispatchEvent(new Event('signout'))
   }
   else console.log('Didn\'t sign out?')
  },
  get hasLoaded() {
   const{
    asITariffLoaderer:{
     tariffLoader:{state:{twelveHourPrice,nightlyPrice,fiveHourPrice,dailyPrice}},
    },
   }=this
   return !!(twelveHourPrice || nightlyPrice || fiveHourPrice || dailyPrice)
  },
 }),
)